import React, { useState, useEffect, useCallback } from 'react';
import { FaPizzaSlice } from 'react-icons/fa';
import { RadioTileGroup } from 'rsuite';
import api from '../../../services/api';
import RModal from '../../../components/Rsuite/Modal';
import RNavbar from '../../../components/Rsuite/Navbar';
import Tamanhos from '../Tamanhos';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomRadioTile } from '../../../components/CustomRadioTile';
import { MdFastfood } from 'react-icons/md';
import { Bordas } from './components/Bordas';
import { TamanhosPizza } from '../TamanhosPizza';
import { toastSuccess, toastError, toastInfo  } from '../../../toasts';
import { Schedules } from './components/Schedules';
import { Flavors } from './components/Flavors';
import { GroupService } from '../../../services/group/group.services';
import { useAlert } from '../../../contexts/Alert.context';
import { navItems } from './utils/navItems';
import { Details } from './components/Details/Details';
import { Additionals } from '../../../components/Additionals';
import { Footer } from './components/Footer/Footer';
import { Mountings } from './components/Mountings/Mountings';
import * as S from './styles';

const EditarCadastrarGrupo = ({
  modal,
  close,
  id_empresa,
  grupo,
  setGrupos,
  setGrupo,
  listProducts,
}) => {
  const [active, setActive] = useState(grupo?.Id ? 'detalhes' : 'tipo');
  const [idGrupo, setIdGrupo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [codigoPDV, setCodigoPDV] = useState(0);
  const [ativo, setAtivo] = useState('');
  const [sequencia, setSequencia] = useState(0);
  const [exibirPizzasGrupo, setExibirPizzasGrupo] = useState(false);
  const [desabilitarSabores, setDesabilitarSabores] = useState(false);
  const [disponivelCardapio, setDisponivelCardapio] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPizzaGroup, setIsPizzaGroup] = useState(null);
  const [tamanhos, setTamanhos] = useState([]);
  const [borders, setBorders] = useState([]);
  const [selectedsSizes, setSelectedsSizes] = useState([]);
  const [openMountings, setOpenMountings] = useState(false);
  const [selecteds, setSelecteds] = useState([]);

  const { theme } = useCustomTheme();
  const { showAlert } = useAlert();

  const abrirDados = () => {
    if (grupo) {
      setIdGrupo(grupo.Id);
      setDescricao(grupo.Descricao);
      setCodigoPDV(grupo.CodigoPDV);
      setAtivo(grupo.Ativo);
      setSequencia(grupo.Sequencia);
      setExibirPizzasGrupo(Boolean(parseInt(grupo.ExibirPizzasGrupo)));
      setDesabilitarSabores(Boolean(parseInt(grupo.DesabilitarSabores)));
      setIsPizzaGroup(grupo?.IsPizza);
      setDisponivelCardapio(Boolean(parseInt(grupo.CardapioAtivo)));
    }
  };

  function validateFields() {
    if (active === 'tipo') {
      const isValid = isPizzaGroup === true || isPizzaGroup === false;
      if (!isValid) {
        toastError('Preencha todos os campos obrigatórios');
      }

      return isValid;
    }

    const isValid = descricao?.length > 3;

    if (!isValid) {
      toastError('Preencha todos os campos obrigatórios');
    }

    return isValid;
  }

  const editarGrupo = async () => {
    if (idGrupo && descricao && ativo !== '') {
      setIsLoading(true);
      await api
        .patch(`grupo-produto/alterar/${idGrupo}`, {
          Descricao: descricao,
          CodigoPDV: codigoPDV,
          Ativo: ativo,
          Sequencia: sequencia,
          ExibirPizzasGrupo: Number(exibirPizzasGrupo),
          DesabilitarSabores: Number(desabilitarSabores),
          CardapioAtivo: Number(disponivelCardapio),
        })
        .then(({ data }) => {
          toastInfo('Grupo alterado');
          setGrupos((state) => state.map((e) => (e.Id !== data.Id ? e : data)));
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      toastError('Preencha todos os campos obrigatórios');
    }
  };

  const cadastrarGrupo = async () => {
    if (descricao === '') {
      toastError('Preencha todos os campos obrigatórios');
      return;
    }

    try {
      setIsLoading(true);

      const data = await GroupService.create({
        IdEmpresa: id_empresa,
        Descricao: descricao,
        CodigoPDV: codigoPDV,
        Sequencia: sequencia,
        IsPizza: isPizzaGroup,
        CardapioAtivo: Number(disponivelCardapio),
      });

      setGrupos((state) => [...state, data]);
      return data;
    } catch (err) {
      toastError('Ocorreu um erro ao salvar o grupo');
    } finally {
      setIsLoading(false);
    }
  };

  const registerGroupSizes = async (groupId) => {
    try {
      const requestData = {
        IdEmpresa: id_empresa,
        Grupo: groupId,
        TipoPizza: false,
        QtdSabores: 0,
        QtdPedacos: 0,
      };

      const sizes_promises = tamanhos?.map(({ Descricao }) =>
        api.post('tamanho/criar', {
          ...requestData,
          Descricao,
        }),
      );

      await Promise.all(sizes_promises);
      toastSuccess('Tamanhos cadastrados');
    } catch (err) {
      console.log(err);
    }
  };

  const registerPizzaGroupSizes = async (groupId) => {
    if (selectedsSizes.length === 0) {
      return;
    }
    try {
      setIsLoading(true);

      const baseObj = {
        IdGrupo: groupId,
        IdEmpresa: id_empresa,
        Ativo: true,
      };

      const tamanhos_promises = selectedsSizes.map((tamanho) =>
        api.post('grupo-tamanhos', {
          ...baseObj,
          IdTamanho: tamanho.Id,
        }),
      );

      await Promise.all(tamanhos_promises);

      toastSuccess('Tamanhos cadastrados');
    } catch (err) {
      console.log(err);
      toastError('Não foi possivel selecionar tamanhos');
    } finally {
      setIsLoading(false);
    }
  };

  const parseBordersProducts = (grupoId, createdSizes, borders) => {
    const bordersSizes = borders?.map((border) => ({
      ...border,
      tamanhos: border.tamanhos.map((tam) => ({
        ...tam,
        idTamanho: createdSizes.find(
          (size) => size?.Descricao === tam?.descricao,
        ).Id,
      })),
    }));

    const parsed = bordersSizes.map((border) => ({
      Descricao: border.descricao,
      Unidade: 'UN',
      TipoProduto: 'BORDA',
      Grupo: grupoId,
      IdEmpresa: id_empresa,
      Composicao: '',
      PrecoVenda: 0,
      MontagemPrato: 0,
      Fracionado: 0,
      KgInicial: 0,
      FreteGratis: 0,
      Sequencia: 0,
      QtdMinima: 0,
      PrecosTamanhos: border?.tamanhos,
    }));

    return parsed;
  };

  async function handleRegisterBorders(grupoId, createdSizes) {
    if (!grupoId) {
      return;
    }

    setIsLoading(true);

    const newBordersProducts = parseBordersProducts(
      grupoId,
      createdSizes,
      borders,
    );

    const borderProductPromises = newBordersProducts.map((product) =>
      api.post('produto/criar', product),
    );

    await Promise.allSettled(borderProductPromises);

    setIsLoading(false);
  }

  const handleSetTamanhos = useCallback((tamanhosProp) => {
    setTamanhos(tamanhosProp);
  }, []);

  const handleSetBorders = useCallback((bordersProp) => {
    setBorders(bordersProp);
  }, []);

  function handleChangeTipo(value) {
    setIsPizzaGroup(value);
    setActive('detalhes');
  }

  const listar = useCallback(async () => {
    if (grupo?.Id && !isPizzaGroup) {
      const { data } = await api.get(`tamanho/listar/${grupo?.Id}`);
      if (data?.length > 0) {
        setTamanhos(data);
      }
    }
  }, [grupo?.Id, isPizzaGroup]);

  const listGroupSizes = useCallback(async () => {
    api
      .get(`grupo-tamanhos/listar_company/${id_empresa}/${grupo?.Id}`)
      .then(({ data }) => {
        if (!Array.isArray(data)) {
          throw new Error('Invalid data');
        }
        setSelecteds(data ?? []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [grupo?.Id, id_empresa]);

  const listarPizzas = useCallback(async () => {
    if (!isPizzaGroup) {
      return;
    }
    try {
      const { data } = await api.get(`tamanho/listar_pizzas/${id_empresa}`);

      if (!Array.isArray(data) || data?.length === 0) {
        return;
      }

      setTamanhos(data);
    } catch (err) {
      console.error(err);
    }
  }, [id_empresa, isPizzaGroup]);

  async function handleSaveEditSequence() {
    try {
      const updateSizesPromisses = tamanhos.map((tamanho, index) =>
        api.patch(`/tamanho/alterar/${tamanho?.Id}`, {
          Sequencia: index + 1,
        }),
      );

      Promise.all(updateSizesPromisses);
    } catch (err) {
      console.log(err);
    }
  }

  const deleteGroup = async () => {
    const isDeleted = await GroupService.delete(grupo?.Id);

    if (isDeleted) {
      setGrupo(null);
      setGrupos((state) => state.filter((group) => group?.Id !== grupo?.Id));
      close();
    }
  };

  const onDelete = () => {
    showAlert({
      title: `Apagar Grupo ${grupo?.Descricao}`,
      text: 'Deseja realmente apagar esse grupo?',
      onSubmit: deleteGroup,
      submitText: 'Apagar Grupo',
    });
  };

  const handleConfirm = async () => {
    const isValid = validateFields();

    if (!isValid) {
      return;
    }

    if (grupo) {
      editarGrupo();
      handleSaveEditSequence();
      return;
    }

    const activeTypes = {
      tipo: 'detalhes',
      detalhes: isPizzaGroup ? 'tamanhos-pizza' : 'tamanhos',
      'tamanhos-pizza': 'bordas',
    };

    if (Object.keys(activeTypes).includes(active)) {
      return setActive(activeTypes[active]);
    }

    const createdGroup = await cadastrarGrupo();

    if (isPizzaGroup) {
      await registerPizzaGroupSizes(createdGroup?.Id);
      await handleRegisterBorders(createdGroup?.Id, tamanhos);
    }

    if (!isPizzaGroup && tamanhos.length > 0) {
      registerGroupSizes(createdGroup?.Id);
    }

    close();
  };

  function handleBack() {
    const activeTypes = {
      detalhes: 'tipo',
      tamanhos: 'detalhes',
      'tamanhos-pizza': 'detalhes',
      bordas: 'tamanhos-pizza',
    };

    setActive(activeTypes[active]);
  }

  function handleOpenMountings() {
    setOpenMountings((prev) => !prev);
  }

  useEffect(() => {
    setTamanhos([]);
  }, [isPizzaGroup]);

  useEffect(() => {
    if (grupo) {
      abrirDados(grupo);
    }
  }, [grupo]);

  useEffect(() => {
    if (isPizzaGroup) {
      listarPizzas();
      return;
    }
    listGroupSizes();
    listar();
  }, [listar, grupo?.Id, isPizzaGroup, listGroupSizes, listarPizzas]);

  return (
    <RModal
      open={modal}
      onClose={close}
      title={grupo ? `Editar Grupo` : 'Cadastrar Grupo'}
      footer={
        <Footer
          idGrupo={idGrupo}
          onDelete={onDelete}
          active={active}
          handleBack={handleBack}
          isPizzaGroup={isPizzaGroup}
          handleConfirm={handleConfirm}
          onOpenMountings={handleOpenMountings}
          isLoading={isLoading}
          grupo={grupo}
          close={close}
        />
      }
    >
      <RNavbar
        active={active}
        setActive={setActive}
        style={{ marginBottom: 30 }}
        navItens={navItems({ grupo, isPizzaGroup })}
      />

      <S.Content>
      <S.TabPanel key={active}>
        {active === 'tipo' && (
          <RadioTileGroup value={isPizzaGroup} onChange={handleChangeTipo}>
            <CustomRadioTile
              label="Tipo Pizza"
              value={true}
              icon={
                <FaPizzaSlice
                  size={26}
                  color={
                    isPizzaGroup === true
                      ? theme.colors.primary
                      : theme.colors.textSecondary
                  }
                />
              }
            >
              Grupo para pizzas
            </CustomRadioTile>
            <CustomRadioTile
              label="Outros"
              value={false}
              icon={
                <MdFastfood
                  size={26}
                  color={
                    isPizzaGroup === false
                      ? theme.colors.primary
                      : theme.colors.textSecondary
                  }
                />
              }
            >
              Grupo para demais produtos ex: Hamburguer, Bebidas, Acaí, etc...
            </CustomRadioTile>
          </RadioTileGroup>
        )}

        {active === 'detalhes' && (
          <Details
            descricao={descricao}
            setDescricao={setDescricao}
            codigoPDV={codigoPDV}
            setCodigoPDV={setCodigoPDV}
            sequencia={sequencia}
            setSequencia={setSequencia}
            disponivelCardapio={disponivelCardapio}
            setDisponivelCardapio={setDisponivelCardapio}
          />
        )}
        {active === 'tamanhos' && (
          <Tamanhos
            idGrupo={idGrupo}
            tamanhos={tamanhos}
            handleSetTamanhos={handleSetTamanhos}
          />
        )}
        {active === 'tamanhos-pizza' && (
          <TamanhosPizza
            idGrupo={idGrupo}
            tamanhos={tamanhos}
            handleSetTamanhos={handleSetTamanhos}
            setSelectedsSizes={setSelectedsSizes}
            selectedsSizes={selectedsSizes}
            selecteds={selecteds}
            setSelecteds={setSelecteds}
          />
        )}
        {active === 'bordas' && (
          <Bordas
            borders={borders}
            handleSetBorders={handleSetBorders}
            tamanhos={tamanhos}
            idGrupo={idGrupo}
            idEmpresa={id_empresa}
            selecteds={selecteds}
          />
        )}
        {active === 'horarios' && (
          <Schedules
            isUsing={grupo.UsaHorario}
            groupId={grupo.Id}
            setGrupo={setGrupo}
            setGrupos={setGrupos}
          />
        )}
        {active === 'sabores' && (
          <Flavors
            groupId={grupo.Id}
            exibirPizzasGrupo={exibirPizzasGrupo}
            setExibirPizzasGrupo={setExibirPizzasGrupo}
            desabilitarSabores={desabilitarSabores}
            setDesabilitarSabores={setDesabilitarSabores}
          />
        )}
        {active === 'adicionais' && <Additionals group={grupo} />}
      </S.TabPanel>
      </S.Content>

      {openMountings && (
        <Mountings
          open={openMountings}
          onClose={handleOpenMountings}
          listProducts={listProducts}
          group={grupo}
        />
      )}
    </RModal>
  );
};

export default EditarCadastrarGrupo;
